import Services from "../../../services";

class JenisKaryawanApi {
  get() {
    return Services.get("jenis_pekerja");
  }

  getPage(page, dataLength, key) {
    return Services.get(`jenis_pekerja/page/?per_page=${dataLength}&page=${page}&q=${key}`);
  }

  getDropdown() {
    return Services.get("jenis_pekerja/dropdown");
  }

  search(key) {
    return Services.get("jenis_pekerja/page/?per_page=10&page=1&q=" + key);
  }

  show(value) {
    return Services.put("jenis_pekerja/show", value);
  }

  hide(value) {
    return Services.put("jenis_pekerja/hide", value);
  }

  create(value) {
    return Services.post("jenis_pekerja", value);
  }

  update(value) {
    return Services.put("jenis_pekerja", value);
  }

  delete(value) {
    return Services.post("jenis_pekerja/delete", value);
  }
}

export default new JenisKaryawanApi();
